import { Injectable } from '@angular/core';
import SecureLS from 'secure-ls';

@Injectable({
  providedIn: 'root',
})
export class SecurePersistStateService {
  private ls: SecureLS;
  private storageKey: string = 'app-state';

  constructor() {
    // Initialize SecureLS with desired options
    this.ls = new SecureLS({ encodingType: 'aes', isCompression: false });
  }

  // Save data to localStorage
  setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  // Get data from localStorage
  getItem(key: string): any {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  // Save the state to encrypted localStorage
  saveToMainSecureState(data: any): void {
    try {
      this.ls.set(this.storageKey, data);
    } catch (error) {
    }
  }

  saveSecureData(key: string, data: any) {
    try {
      let currentState = this.loadState() || {};
      currentState[key] = data;
      this.saveToMainSecureState(currentState);
    } catch (error) {
    }
  }

  removeSecureData(key: string) {
    try {
      let currentState = this.loadState() || {};
      delete currentState[key];
      this.saveToMainSecureState(currentState);
    } catch (error) {
    }
  }

  getData(key: string): any {
    const state = this.loadState();
    return state[key]?.__zone_symbol__value || state[key];
  }

  // Load the state from encrypted localStorage
  loadState(): any {
    try {
      const state = this.ls.get(this.storageKey);
      if (state === null || state === undefined) {
        return undefined;
      }
      return state;
    } catch (error) {
      return undefined;
    }
  }

  // Clear the persisted encrypted state
  clearState(): void {
    try {
      this.ls.remove(this.storageKey);
    } catch (error) {
    }
  }

  // Update a portion of the state (deep merge)
  updateState(key: string, partialState: any): void {
    const currentState = this.loadState() || {};
    const newState = { ...currentState, [key]: partialState };
    this.saveToMainSecureState(newState);
  }
}
